import React, { Component } from 'react'
import style from './style.css'

class Select extends Component {

    render() {

        const renderOptions = options => {
            if(!options) return false
            return options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.value}
                </option>
            ))
        }

        let { handleChange, ...other } = this.props

        return (
            <label>
                <select
                    {...other}
                    className={`
                        ${style.text}
                        ${style.select}
                        ${(this.props.transparent) ? style.transparent : ''}
                        ${(this.props.theme) ? style['theme'+this.props.theme] : ''}
                        ${this.props.className || ''}
                        `}
                    onChange={(e) => this.props.handleChange(e) || null}
                    disabled={this.props.disabled}
                    >
                    {renderOptions(this.props.options) || this.props.children}
                </select>
                <div className={style.arrow} />

                {this.props.label && (
                    <span className={style.placeholderFloat}>
                        <span className={style.placeholderFloatText}>{this.props.label}</span>
                        <hr className={style.lineWhite} />
                    </span>
                )}
            </label>
        )
    }
}

export default Select



// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Forms/select.js